export default __webpack_public_path__ + "static/sizzle_desktop-7fab66a7847ace1704960171ff9de1a4.mp4";